module.exports = __webpack_public_path__ + "img/Support.54e05cdb.svg";